import React, {KeyboardEvent, useEffect, useState} from 'react';
import SearchIcon from "../../../../ui/svg/common/search";

import TopTabs from "../components/top-tabs";
import SearchItem from "../components/search-item";
import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import Pagination from "../components/pagination";
import {GetSearchItemImgPath, GetSearchItemType, OnPageLoad, SearchAction,GetSearchItemSvg} from "../services/logic-helper";
import Preloader from "../../../../ui/svg/common/preloader";


/**
 * the entry point
 */
const App: React.FC = () => {

    const [isLoading, setIsLoading] = useState(false);

    const CurrentMainTab = useAppSelector((store) => store.CurrentMainTab);
    const NumberOfItemsPerPage = useAppSelector((store) => store.NumberOfItemsPerPage);
    const SearchResults = useAppSelector((store) => store.SearchResults);
    const TotalNumberOfResults = useAppSelector((store) => store.TotalNumberOfResults);
    const SearchQuery = useAppSelector((store) => store.SearchQuery);
    const ShowNoResults = useAppSelector((store) => store.ShowNoResults);

    const dispatch = useAppDispatch();

    /**
     * handle key up event - query search on Enter
     */
    const handleKeyUp = async (evt: KeyboardEvent) => {

        if(evt.key === 'Enter') {
            await Search();
        }
    };

    /**
     * handle search action on page number 1
     */
    const Search = async () => {
        await SearchAction(SearchQuery,CurrentMainTab,0,dispatch,false,setIsLoading);
    };

    /**
     * On page load - init url patams, query search results ( if searchtext param is not null)
     */
    useEffect(() => {
        (async () => {

            await OnPageLoad(dispatch,setIsLoading);

        })();

    }, [dispatch]);

    window.onpopstate = async function (e) {

        if (typeof e.state == "object" && e.state != null && e.state.reloadPage != null) {
            await OnPageLoad(dispatch, setIsLoading);
        }
    };

    return (
        <div className="waves-box-lg mx-auto px-5 md:px-12 xl:px-0 mb-24 overflow-hidden">
            <div className="md:hidden flex items-center justify-between p-4">
                <div className="font-bold text-2xl">Search Results</div>

            </div>
            <div className="w-full flex items-center justify-center">
                <div className="waves-box-sm md:mt-20 border box-border border-gray-200-ho bg-gray-100 outline-none rounded-full flex items-center justify-center">
                    <input
                        type="text"
                        className="bg-gray-100 rounded-full flex-1 p-3 md:p-5 outline-none pl-6 xl:pl-8"
                        value={ SearchQuery === null ? "" : SearchQuery }
                        placeholder="Search"
                        aria-label="Search"
                        onKeyUp={ async evt => {
                            await handleKeyUp(evt);
                        }}
                        onChange={evt => {
                            dispatch(
                                rootActions.main({
                                    SearchQuery:evt.target.value
                                })
                            );
                        }}
                    />
                    <div className="p-3 md:p-5 pr-4 xl:pr-8 cursor-pointer" onClick={Search}>
                        <SearchIcon width="15px" color="#252525" title="Filter" />
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center mt-4 md:mb-5">
                <div className="w-full flex items-center justify-center">
                    <div className="w-full md:w-auto">
                        <TopTabs setIsLoading={setIsLoading}/>
                    </div>
                </div>
            </div>
            <div className="hidden md:block w-full border-b border-b-gray-600"></div>
            <div className="lg:flex lg:items-center lg:justify-center">
                <div className="waves-box-md mx-auto mx-auto text-sm md:text-base pb-0">
                    {!isLoading && SearchResults.length > 0 &&
                        <ul>
                            {SearchResults.map((searchResult,index) => {

                                let searchResultImgPath = GetSearchItemImgPath(searchResult.imagePath.toLowerCase());
                                let searchResultSvg = GetSearchItemSvg(searchResult.imagePath.toLowerCase(),searchResult.urlPath.toLowerCase());
                                let searchResultType = GetSearchItemType(searchResult.imagePath.toLowerCase(),searchResult.urlPath.toLowerCase());

                                return <li key={searchResult.urlPath}>
                                            <SearchItem searchResultType={searchResultType}
                                                        searchResultImgPath={searchResultImgPath}
                                                        searchResultSvg={searchResultSvg}
                                                        searchResult={searchResult}
                                                        isLast={index === SearchResults.length - 1}
                                                        position={ index }
                                            />
                                        </li>;
                            })}

                        </ul>}
                    {isLoading &&
                        <div className="flex items-center justify-center mb-4 pt-4 ">
                            <Preloader width="25px" height="25px" color="#4f4f4f" />
                            <div className="ml-4">Fetching Results…</div>
                        </div>
                    }
                    {ShowNoResults && <div className="w-full text-center pt-4 ">No results were found.</div>}
                    {TotalNumberOfResults > NumberOfItemsPerPage && <Pagination setIsLoading={setIsLoading}/>}

                </div>


            </div>
        </div>

    );
};

export default App;

